import { Link } from "react-router-dom";
import LegalLayout, { Section, UL, Item, COMPANY } from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund & Cancellation Policy"
      updated="June 1, 2026"
      intro={`This policy explains how subscription billing, cancellation, and refunds work for paid plans of ArcaCentum Credit and other services offered by ${COMPANY.name}. It is part of our Terms of Service.`}
    >
      <Section title="1. Free Plan">
        <p>ArcaCentum Credit offers a free plan with no payment required and no credit card required at signup. You can explore the core product before ever paying.</p>
      </Section>

      <Section title="2. Subscription Billing">
        <UL>
          <Item>Paid plans are billed in advance on a recurring monthly or annual basis through Stripe, our payment processor.</Item>
          <Item>Your subscription renews automatically at the end of each billing period unless you cancel before the renewal date.</Item>
          <Item>Invoices and receipts are emailed to you and are available anytime from your Billing page and the Stripe customer portal.</Item>
        </UL>
      </Section>

      <Section title="3. Cancellation — Anytime, Self-Service">
        <UL>
          <Item>You may cancel your subscription at any time, no questions asked, from the <span className="text-white/85">Billing page</span> inside ArcaCentum Credit or through the Stripe customer portal ("Manage Billing").</Item>
          <Item>When you cancel, your subscription remains active and you keep full access to your paid features until the <span className="text-white/85">end of your current billing period</span>. You will not be charged again.</Item>
          <Item>After the period ends, your account automatically moves to the free plan — your data is retained and remains accessible under free-plan limits.</Item>
          <Item>If you change your mind before the period ends, you can resume your subscription from the Billing page.</Item>
        </UL>
      </Section>

      <Section title="4. Refunds">
        <UL>
          <Item label="No partial or prorated refunds.">Because you retain full access through the end of the billing period after cancelling, we do not provide refunds or credits for partial subscription periods, unused time, or unused features, except where required by applicable law.</Item>
          <Item label="Billing errors and duplicate charges.">If you believe you were charged in error — for example, a duplicate charge or a charge after a confirmed cancellation — contact us at {COMPANY.email} within 30 days of the charge. Verified billing errors will be refunded in full to your original payment method, typically within 5–10 business days.</Item>
          <Item label="Service discontinuation.">If we permanently discontinue a paid service, prepaid fees covering the discontinued period will be refunded pro-rata.</Item>
        </UL>
      </Section>

      <Section title="5. Plan Changes">
        <UL>
          <Item label="Upgrades">take effect immediately; billing is handled by Stripe according to your new plan.</Item>
          <Item label="Downgrades">take effect at the end of your current billing period; you keep your current plan's features until then.</Item>
        </UL>
      </Section>

      <Section title="6. How to Cancel or Get Help">
        <UL>
          <Item>In-app: ArcaCentum Credit → <span className="text-white/85">Billing → Cancel subscription</span> (or "Manage Billing" for the Stripe portal).</Item>
          <Item>Email: <a href={`mailto:${COMPANY.email}`} className="text-cyan-300 hover:text-cyan-200">{COMPANY.email}</a> — we respond to billing inquiries within 2 business days.</Item>
        </UL>
        <p>For full terms, see our <Link to="/terms" className="text-cyan-300 hover:text-cyan-200">Terms of Service</Link> and <Link to="/privacy" className="text-cyan-300 hover:text-cyan-200">Privacy Policy</Link>.</p>
      </Section>
    </LegalLayout>
  );
}
